export default class RoleGroupsService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getListOptions() {
		return this.apiService.callGet('me/roleGroups/getListOptions');
	}

	createEntity(params){
		return this.apiService.callPost('me/roleGroups', params);
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/roleGroups/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('me/roleGroups', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/roleGroups/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/roleGroups/' + id, params)
	}

	getSimpleList() {
		return this.apiService.callGet('me/roleGroups/simple_list')
	}

	getEditAllowedSectionList() {
		return this.apiService.callGet('me/roleGroups/editAllowedSectionList')
	}
}



// WEBPACK FOOTER //
// ./src/service/RoleGroupsService.js